import React from "react";

import Meaning from "./meaning/Meaning";
import Phonetics from "./phonetics/Phonetics";

export default function Result(props) {
  if (props.results) {
    return (
      <div className="Results">
        <section>
          <h2>{props.results.word.toUpperCase()}</h2>
          <Phonetics phonetics={props.results.phonetics} />
        </section>
        {props.results.meanings.map(function (meaning, idx) {
          return (
            <div key={idx}>
              <Meaning meaning={meaning} />
            </div>
          );
        })}
      </div>
    );
  } else {
    return null;
  }
}
